import React, { FC, useState, useEffect, useContext } from 'react'
// import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import cookie from 'react-cookies'
import firebase from 'firebase/app'
import _ from 'lodash'
import moment from 'moment'
import platform from 'platform'
import { isMobile } from 'react-device-detect'
import AppContext from '../../context/appContext'

import 'firebase/firestore'
import 'firebase/database'

// own Logic
import {
  createMeetingWithAttendies,
  getMeetingWithAttendies,
  userJoinToMeeting,
  addUserToQueue,
  chimeRemoveUserFromQueue,
} from '../../Api/ChimeApi'
import { getUserData } from '../../Api/backendApi'
// import { obtainFolderVideos } from '../../Api/base'
import history from '../../history'

import { getUserAuthData } from '../../Api/newUserAuth'

// own Views
import MainView from './views/MainView'
import ChooseFolderView from './views/ChooseFolderView'
import UnallowedDevicesRedirect from './views/UnallowedDevicesRedirect'

interface ConferencesScreenProps {}

const ConferencesScreen: FC<ConferencesScreenProps> = () => {
  // const appAllfolders = useSelector((state: any) => state.folders.folders)
  const appContext = useContext(AppContext)
  const [meeting, setMeeting] = useState(null)
  const [attendee, setAttendee] = useState(null)
  const [conference, setConferencesData] = useState(Object)
  const [user, setUserData] = useState(Object)
  const [isUserInQueue, setUserInQueue] = useState(false)
  const [userQueuedRoomKey, setUserQueuedRoomKey] = useState(Number)
  const [userFirebaseIndexKey, setUserFirebaseIndexKey] = useState('')
  const [isRoomCreated, setIsRoomCreated] = useState(false)
  const [masterAttendee, setMasterAttendee] = useState(null)
  const [lastUserId, setLastUserId] = useState(null)
  const [userQueuedMiazgaId, setUserQueuedMiazgaId] = useState(null)
  const [userQueuedVideoId, setUserQueuedVideoId] = useState(null)
  const [userQueuedMiazgaName, setUserQueuedMiazgaName] = useState('')
  const [userQueuedMiazgaFolderAllVideos, setUserQueuedMiazgaFolderAllVideos] =
    useState([])
  const [userQueuedMiazgaFolderVideo, setUserQueuedMiazgaFolderVideo] =
    useState({})
  const [userQueuedMiazgaFolderVideoUri, setUserQueuedMiazgaFolderVideoUri] =
    useState('')
  const [userGetMeetingRequestDone, setUserGetMeetingRequestDone] =
    useState(null)
  const [isUserKicked, setIsUserKicked] = useState(false)
  const [isUserKickedBackend, setUserKickedBackend] = useState(false)
  const [userChosedMiazgaFolder, setUserChosedMiazgaFolder] = useState(null)
  const [seletedMiazgaFolder, setSeletedMiazgaFolder] = useState(Object)
  const [selectedVideo, setSelectedVideo] = useState(null)
  const [selectedVideoId, setSelectedVideoId] = useState(null)
  const [isSessionQueueOpen, setSessionQueueOpen] = useState({
    first: false,
    second: false,
  })
  const [isFirstQueueOpen, setFirstQueueOpen] = useState(false)
  const [isSecondQueueOpen, setSecondQueueOpen] = useState(false)
  const [hideReturnToRoomBanner, setHideToRoomBanner] = useState(true)
  const [
    userShouldBePushedFromFirstQueue,
    setUserShouldBePushedFromFirstQueue,
  ] = useState(false)
  const [showBackToCorrectQueueBanner, setShowBackToCorrectQueueBanner] =
    useState(false)

  const [userQueueInfo, setUserQueueInfo] = useState(Object)
  const [msToPushUserFromFirstQueue, setMsToPushUserFromFirstQueue] =
    useState(null)

  // TIME MANAGERS STATE
  const [queueOpenTime, setQueueOpenTime] = useState()
  const [queueRedirectTime, setQueueRedirectTime] = useState()
  const [videoStartTime, setVideoStartTime] = useState()
  const [redirectUserTimeCounter, setRedirectUserTimeCounter] = useState(Object)
  const [startVideoTimeCounter, setStartVideoTimeCounter] = useState()
  const [shouldUserBePushedToVideo, setShouldUserBePushedToVideo] =
    useState(false)
  const [shouldQueueBeOpen, setShouldQueueBeOpen] = useState(false)
  const [shouldVideoStarted, setShouldVideoStarted] = useState(false)
  const [isRoomCreateRequestDone, setIsRoomCreateRequestDone] = useState(false)
  const [roomUsers, setRoomUsers] = useState(Object)
  // const [isRoomCreateRequestDone, setIsRoomCreateRequest] = useState(false)

  // First - get user and create meeting
  useEffect(() => {
    getUser()
    listenForFirebaseChange()

    return () => {
      if (isUserInQueue && userQueuedVideoId) {
        handleUserleaveQueue(userQueuedVideoId)
      }
    }
  }, [])

  useEffect(() => {
    setRoomCreated()
  }, [attendee, meeting])

  // gather user data

  const getUser = async () => {
    // let userInfo: any

    let userInfo: any = await getUserAuthData()

    if (userInfo !== undefined) {
      await setUserData(userInfo)
      // await listenForFirebaseChange()

      if (userInfo.chime_is_kicked) {
        setUserKickedBackend(true)
      }
    }
  }

  const handleSelectVideo = (video: any) => {
    cookie.save('selectedConferencesVideo', video)
    setSelectedVideo(video)
  }

  const handleUserBackToRoom = (option: boolean) => {
    if (option == true) {
      // cookie.remove('userPushedToVideo')

      setHideToRoomBanner(false)
      redirectUserToConferenceRoom()
    }

    if (option == false) {
      handleUserleaveQueue(userQueuedRoomKey)
      cookie.remove('userPushedToVideo', { path: '/' })

      setHideToRoomBanner(false)

      return
    }
  }

  const handleUserBackToCorrectQueue = (mode: boolean) => {
    if (mode == true) {
      setSelectedVideoId(userQueuedVideoId)
    } else {
      setShowBackToCorrectQueueBanner(true)
      handleUserleaveQueue(userQueuedRoomKey)
    }
  }

  // listen for firebase
  useEffect(() => {
    getRoomInfo()
    checkIfUserKicked()
    listenForCreatedRoomField()
    // handleUserCreateRoom()
    checkIfUserIsInQueue()
    // obtainRoomVideo()
    // sendRequestForCreateRoom()
  }, [user, conference])

  useEffect(() => {
    getSelectedVideoKey(selectedVideo)

    if (selectedVideo) {
      cookie.save('selectedConferencesVideo', selectedVideo)
    }
  }, [selectedVideo])

  // PUSH USER TO ROOM WHEN ITS TIME TO
  useEffect(() => {
    if (shouldUserBePushedToVideo) {
      redirectUserToConferenceRoom()
    }
  }, [shouldUserBePushedToVideo])

  useEffect(() => {
    let isPushed = false
    // let isRequestDone = false

    const interval = setInterval(() => {
      // MANAGING QUEUE TIME

      // CHECK IF CONFERENCE IS OBTAINED
      if (conference.sessions && conference.sessions.length > 0) {
        // set in localstate important time settings - open queue time, redirect user time and start video timers
        if (!queueOpenTime || !queueRedirectTime || !videoStartTime) {
          setQueueOpenTime(conference.sessions[0].start_date)
          setQueueRedirectTime(conference.sessions[0].redirect_users_date)
          setVideoStartTime(conference.sessions[0].start_video)
        }

        //! DEFINE TIME UNTILL QUEUE OPEN

        //! OPEN AND CLOSE QUEUE TIME SETTING
        // if current time millisecond value is bigger than database time milisecond value then change localstate value of shouldQueueBeOpen and generally = open queue
        if (
          moment().valueOf() >
            moment(conference.sessions[0].start_date).valueOf() &&
          moment().valueOf() <
            moment(conference.sessions[0].redirect_users_date).valueOf()
        ) {
          setShouldQueueBeOpen(true)

          // !QUEUE END COUNTDOWN SETTINGS
          // here define hours, minutes, seconds until queue extends

          let minutesToEndQueue: any
          let secondsToEndQueue: any
          const msToEndQueue: any =
            moment(conference.sessions[0].redirect_users_date).valueOf() -
            moment().valueOf()

          if (msToEndQueue > 60000) {
            minutesToEndQueue = Math.floor(msToEndQueue / 60000)
            secondsToEndQueue = Math.floor(
              (msToEndQueue % (60000 * minutesToEndQueue)) / 1000
            )
          } else {
            minutesToEndQueue = 0
            secondsToEndQueue = Math.floor(msToEndQueue / 1000)
          }

          setRedirectUserTimeCounter({
            minutesToEndQueue: minutesToEndQueue,
            secondsToEndQueue: secondsToEndQueue,
          })
        } else {
          setShouldQueueBeOpen(false)
        }

        //! SEND REQUEST FOR CREATE ROOM

        if (
          moment(conference.sessions[0].redirect_users_date).valueOf() - 60000 <
          moment().valueOf()
        ) {
          sendRequestForCreateRoom()
        }

        //! PUSH USER TO VIDEO SETTING
        // if current time millisecond value is bigger than database time milisecond value then change localstate value of shouldUserBePushedToVideo and generally = push user to room
        if (
          moment().valueOf() >
            moment(conference.sessions[0].redirect_users_date).valueOf() &&
          moment().valueOf() <
            moment(conference.sessions[0].start_video).valueOf()
        ) {
          setShouldUserBePushedToVideo(true)
        } else {
          setShouldUserBePushedToVideo(false)
        }

        //! VIDEO START SETTING
        // if current time millisecond value is bigger than database time milisecond value then change localstate value of shouldQueueBeOpen and generally = start video
        if (
          moment().valueOf() >
          moment(conference.sessions[0].start_video).valueOf()
        ) {
          // check if user is in queue after video starts and remove user from queue
          if (isUserInQueue) {
            handleUserleaveQueue(userQueuedRoomKey)
          }
          // checkIfUserIsInQueue()
          setShouldVideoStarted(true)
        }
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [conference, attendee, meeting])

  const getSelectedVideoKey = (selectedVideo: any) => {
    if (selectedVideo && selectedVideo.name) {
      if (!selectedVideo.name.includes('Trening')) {
        setSelectedVideoId(0)
      } else {
        setSelectedVideoId(selectedVideo.video_order)
      }
    }
  }

  const checkIfUserKicked = () => {
    conference.rooms &&
      conference.rooms.forEach((room: any) => {
        if (room.users && Object.keys(room.users).length) {
          for (const key of Object.keys(room.users)) {
            if (
              room.users[key].user_id &&
              room.users[key].user_id !== undefined &&
              room.users[key].user_id === user.id &&
              room.users[key].is_user_kicked
            ) {
              setIsUserKicked(true)

              handleUserleaveQueue(room.key)

              return
            } else {
              setIsUserKicked(false)
            }
          }
        }
      })
  }

  const getQueuedUsers = (room: any) => {
    let users: any = []
    let value: any
    let key: any

    if (room.users) {
      for ([key, value] of Object.entries(room.users)) {
        users = [...users, value.user_name]
      }
    }

    return users
  }

  const checkIfUserIsInQueue = () => {
    setUserInQueue(false)
    let isUserInQueue: boolean = false

    conference.rooms &&
      conference.rooms.forEach((room: any) => {
        if (room.users && Object.keys(room.users).length) {
          for (const key of Object.keys(room.users)) {
            if (
              room.users[key].user_id &&
              room.users[key].user_id !== undefined &&
              room.users[key].user_id === user.id
            ) {
              setUserInQueue(true)
              setUserQueuedRoomKey(room.key)
              setUserFirebaseIndexKey(key)

              setUserQueueInfo(conference.rooms[room.key])

              const userQueueRef = firebase.database().ref(`/rooms/${room.key}`)

              // if (cookie.load('selectedConferencesVideo'))
              //   setSelectedVideo(cookie.load('selectedConferencesVideo'))

              return (isUserInQueue = true)
            } else {
              // if (cookie.load('selectedConferencesVideo')) {
              //   cookie.remove('selectedConferencesVideo')
              // }
            }
          }
        }
        return isUserInQueue
      })
  }

  const handleUserJoinQueue = (roomKey: number) => {
    addNewUserToQueue(roomKey)
  }

  const handleUserleaveQueue = (roomKey: number) => {
    removeUserFromQueue(roomKey)
  }

  const addNewUserToQueue = async (roomKey: number) => {
    addUserToQueue(roomKey, user.id)

    // let userData = {
    //   user_name: user.name,
    //   user_id: user.id,
    //   userCreatedRoom: false,
    //   user_enter_room_time: Date.now(),
    // }

    // await firebase.database().ref(`/rooms/${roomKey}/users/`).push(userData)
  }

  // const flagRoomAsCreated = (roomKey: number) => {
  //   const roomRef = firebase.database().ref(`/rooms/${roomKey}/`)

  //   roomRef.update({
  //     is_room_created: true,
  //   })
  // }

  const removeUserFromQueue = async (roomKey: number) => {
    await setMeeting(null)
    await setAttendee(null)

    // await firebase
    //   .database()
    //   .ref(`rooms/${roomKey}/users/${userFirebaseIndexKey}/`)
    //   .remove()
    chimeRemoveUserFromQueue(roomKey, user.id)
    setUserInQueue(false)
  }

  const listenForCreatedRoomField = async () => {
    conference.rooms &&
      conference.rooms.forEach(async (room: any) => {
        if (room.users && Object.keys(room.users).length) {
          for (const key of Object.keys(room.users)) {
            if (
              room.users[key].user_id &&
              room.users[key].user_id !== undefined &&
              room.users[key].user_id === user.id
            ) {
              setTimeout(async () => {
                if (room.is_room_created && !meeting && !attendee) {
                  let res = await userJoinToMeeting(room.key)

                  if (res) {
                    handleGetMeetingAndAttendee()
                  }
                  return
                }
              }, 100)
            }
          }
        }
      })
  }

  // const handleUserCreateRoom = async () => {
  //   let max = 0
  //   let lastUserId: any

  //   conference.rooms &&
  //     conference.rooms.forEach( async (room: any) => {
  //       if (
  //         room.users &&
  //         Object.keys(room.users).length &&
  //         Object.keys(room.users).length == 2 && !room.is_room_created && !isRoomCreateRequestDone
  //       ) {
  //         await setIsRoomCreatedRequestDone(true)
  //         await handleCreateMeetingAndAttendee(room.key)
  //         // for (const key of Object.keys(room.users)) {
  //         //   if (room.users[key].user_enter_room_time > max) {
  //         //     max = room.users[key].user_enter_room_time
  //         //     setLastUserId(room.users[key].user_id)
  //         //     lastUserId = room.users[key].user_id
  //         //   }
  //         // }

  //         // if (lastUserId == user.id && !room.is_room_created && !isRoomCreatedRequestDone) {
  //         //   handleCreateMeetingAndAttendee(room.key)
  //         //   return
  //         // }
  //       }
  //     })
  // }

  const listenForFirebaseChange = async () => {
    var queueDataRef = firebase.database().ref('/')
    queueDataRef.on('value', async (snapshot) => {
      const data = snapshot.val()
      setConferencesData(data)
    })
  }

  // const handleCreateMeetingAndAttendee = async (roomId: number) => {
  //   const meetingInfo: any = await createMeetingWithAttendies(roomId)
  // }

  const handleGetMeetingAndAttendee = async () => {
    const existingmeeting: any = await getMeetingWithAttendies()
    let userRequestDone: boolean = false

    if (!meeting && !attendee) {
      await setMeeting(existingmeeting.meeting)
      await setAttendee(existingmeeting.attendee)
    }
  }

  const setRoomCreated = () => {
    setIsRoomCreated(!isRoomCreated)
  }

  const getRoomInfo = () => {
    conference.rooms &&
      conference.rooms.forEach((room: any) => {
        if (room.users) {
          for (const key of Object.keys(room.users)) {
            if (room.users[key].user_id == user.id) {
              setUserQueuedMiazgaId(room.miazga_id)
              setUserQueuedVideoId(room.video_id)
            }
          }
        }
      })
  }

  const selectMiazga = (folder: any) => {
    let path = folder.uri
    let albumId = folder.dashboard_order
    let albumKey = folder.dashboard_order - 7
    let folderName = folder.name
    let albumVimeoId = folder.vimeo_album_id

    setSeletedMiazgaFolder({
      folderName,
      albumId,
      albumKey,
      path,
      albumVimeoId,
    })
    cookie.save('selectedMiazga', {
      folderName: folderName,
      albumId: albumId,
      albumKey: albumKey,
      path: path,
      albumVimeoId: albumVimeoId,
    })
    setUserChosedMiazgaFolder(true)
  }

  const sendRequestForCreateRoom = async () => {
    if (conference && conference !== null && conference !== undefined) {
      if (Object.keys(conference).length != 0 && userQueuedRoomKey) {
        const usersRoom = conference.rooms[userQueuedRoomKey]

        if (
          usersRoom.users &&
          usersRoom.users !== null &&
          usersRoom.users !== undefined
        ) {
          if (
            Object.keys(usersRoom.users).length >= 2 &&
            !usersRoom.is_room_created &&
            !isRoomCreateRequestDone
          ) {
            //  await new endpoint for creating room
            const meetingInfo: any = await createMeetingWithAttendies(
              userQueuedRoomKey
            )
            setIsRoomCreateRequestDone(true)
            if (meetingInfo) {
              await setIsRoomCreateRequestDone(true)
            }
          }
        }
      }
    }
  }

  const redirectUserToConferenceRoom = () => {
    if (meeting && attendee) {
      history.push({
        pathname: `/treningi-wspolne/pokoj/${meeting.MeetingId}/`,
        state: {
          meeting: meeting,
          attendee: attendee,
          masterAttendee: masterAttendee,
          userChosedMiazgaId: userQueuedMiazgaId,
          userChosedVideoId: userQueuedVideoId,
          userQueuedRoomKey: userQueuedRoomKey,
          userFirebaseIndexKey: userFirebaseIndexKey,
          userChoosedVideo: selectedVideo,

          // userQueuedMiazgaFolderVideoUri: userQueuedMiazgaFolderVideoUri,
        },
      })
    }
  }

  return (
    <>
      {(platform.name == 'Safari' || isMobile) && <UnallowedDevicesRedirect />}
      {!userChosedMiazgaFolder && platform.name !== 'Safari' && !isMobile ? (
        <ChooseFolderView selectMiazga={selectMiazga} />
      ) : (
        platform.name !== 'Safari' &&
        !isMobile && (
          <MainView
            redirectUserToConferenceRoom={redirectUserToConferenceRoom}
            handleUserJoinQueue={handleUserJoinQueue}
            conference={conference}
            isUserInQueue={isUserInQueue}
            userQueuedRoomKey={userQueuedRoomKey}
            handleUserleaveQueue={handleUserleaveQueue}
            getQueuedUsers={getQueuedUsers}
            isRoomCreated={isRoomCreated}
            isUserKicked={isUserKicked}
            isUserKickedBackend={isUserKickedBackend}
            meeting={meeting}
            attendee={attendee}
            seletedMiazgaFolder={seletedMiazgaFolder}
            setSelectedVideo={handleSelectVideo}
            selectedVideoId={selectedVideoId}
            selectedVideo={selectedVideo}
            isSessionQueueOpen={isSessionQueueOpen}
            isFirstQueueOpen={isFirstQueueOpen}
            isSecondQueueOpen={isSecondQueueOpen}
            handleUserBackToRoom={handleUserBackToRoom}
            hideReturnToRoomBanner={hideReturnToRoomBanner}
            userQueuedMiazgaId={userQueuedMiazgaId}
            userQueuedVideoId={userQueuedVideoId}
            handleUserBackToCorrectQueue={handleUserBackToCorrectQueue}
            showBackToCorrectQueueBanner={showBackToCorrectQueueBanner}
            msToPushUserFromFirstQueue={msToPushUserFromFirstQueue}
            shouldQueueBeOpen={shouldQueueBeOpen}
            redirectUserTimeCounter={redirectUserTimeCounter}
            shouldUserBePushedToVideo={shouldUserBePushedToVideo}
            userQueueInfo={userQueueInfo}
          />
        )
      )}
    </>
  )
}

export default ConferencesScreen
